import { AlertRuleEvent } from '@/types/event';
import { EventsDataResult } from './eventsDataShared';
import { UseAlertsQueryOptions, useAlertsQuery } from './useAlertsQuery';
import { useInfiniteList } from './useInfiniteList';

export interface UseAlertsDataOptions extends UseAlertsQueryOptions {
    refreshInterval?: number;
}

const getAlertId = (alert: AlertRuleEvent) => alert.event.id;

export function useAlertsData({
    refreshInterval = 0,
    ...queryOptions
}: UseAlertsDataOptions = {}): EventsDataResult<AlertRuleEvent> {
    const { cacheKey, pageStateKey, fetchPage } = useAlertsQuery(queryOptions);
    return useInfiniteList<AlertRuleEvent>({
        cacheKey,
        pageStateKey,
        fetchPage,
        getId: getAlertId,
        revalidateFirstPage: refreshInterval > 0,
        refreshInterval,
    });
}
